import api from './client'
import type { Question } from '../types'

export const questionnaireApi = {
  get: () => api.get<Question[]>('/questionnaire').then((r) => r.data),
}
